"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ElstrId_1 = __importDefault(require("./ElstrId"));
var ElstrBaseApp_1 = __importDefault(require("./ElstrBaseApp"));
var BackendVersion_1 = require("./constants/BackendVersion");
var ElstrLanguage_1 = require("./ElstrLanguage");
/**
 * This is the class for IO used in Elstr projects
 *
 * options attributes:
 *     abortStaleRequests: aborts stale requests (only works with requestJsonRpc)
 *
 * @class ElstrIo
 */
var ElstrIo = /** @class */ (function () {
    function ElstrIo() {
    }
    /**
     * Use requestJsonRpc for any JSON-RPC requests to the Elstr server
     * @param className
     * @param methodName
     * @param params
     * @param requestMethod [Optional] POST | GET | PUT, defines the request method to use
     * @returns {Request}
     */
    ElstrIo.requestJsonRpc = function (className, methodName, params, requestMethod) {
        if (requestMethod === void 0) { requestMethod = "POST"; }
        return __awaiter(this, void 0, void 0, function () {
            var url, requestData, requestCall, serviceResult, resultMessages, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = ElstrIo.getReqUrl(className);
                        requestData = ElstrIo.getReqData(methodName, params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, window.fetch(url, requestData)];
                    case 2:
                        requestCall = _a.sent();
                        return [4 /*yield*/, requestCall.json()];
                    case 3:
                        serviceResult = _a.sent();
                        if (serviceResult.result) {
                            if (serviceResult.result.hasOwnProperty("message")) {
                                // For backwards compatibility of the Elstr Backend
                                // results that contains a "message" key in the result object
                                // will be returned as an error
                                throw new Error(serviceResult.result.message);
                            }
                            else {
                                if (serviceResult.result.hasOwnProperty("messages")) {
                                    resultMessages = serviceResult.result.messages;
                                    if (Array.isArray(resultMessages)) {
                                        resultMessages.forEach(function (message) {
                                            if (message.hasOwnProperty("level")) {
                                                if (message.level === "EXCEPTION") {
                                                    if (message.hasOwnProperty("message")) {
                                                        throw new Error(message.message);
                                                    }
                                                    else {
                                                        throw new Error(message);
                                                    }
                                                }
                                            }
                                        });
                                    }
                                }
                                return [2 /*return*/, serviceResult.result];
                            }
                        }
                        if (serviceResult.error) {
                            throw new Error(serviceResult.error.message);
                        }
                        throw new Error("Response to ElstrIo was neither a result nor an error\n            Status of response: " + requestCall.status + "\n            and serviceresult: " + serviceResult);
                    case 4:
                        e_1 = _a.sent();
                        // We don't want to console.error in a Test runner like Jest
                        if (process.env.NODE_ENV !== "test")
                            console.error(e_1);
                        throw e_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ElstrIo.getReqData = function (methodName, params) {
        var body = {
            jsonrpc: "2.0",
            method: methodName,
            params: params,
            id: ElstrId_1.default.create(),
        };
        var requestData = {
            credentials: "include",
            method: "POST",
            headers: {
                "accept-encoding": "gzip, deflate",
            },
            body: JSON.stringify(body),
        };
        if (process.env.NODE_ENV === "test") {
            // Apply session cookie in case the service requests requires authentication while using test runners
            requestData.headers.cookie = ElstrIo.COOKIE;
        }
        if (ElstrBaseApp_1.default.ELSTR_BACKEND_VERSION === BackendVersion_1.ELSTR_BACKEND_VERSION.BE2) {
            requestData.headers["accept-language"] = ElstrLanguage_1.activeLang();
        }
        return requestData;
    };
    ElstrIo.getReqUrl = function (className) {
        if (ElstrBaseApp_1.default.ELSTR_BACKEND_VERSION === BackendVersion_1.ELSTR_BACKEND_VERSION.BE1) {
            return "" + ElstrIo.SERVICE_URL + className;
        }
        if (ElstrBaseApp_1.default.ELSTR_BACKEND_VERSION === BackendVersion_1.ELSTR_BACKEND_VERSION.BE2) {
            return ElstrIo.SERVICE_URL + "json-rpc/" + className;
        }
        // Fallback BE1 version
        return "" + ElstrIo.SERVICE_URL + className;
    };
    ElstrIo.throwErrorIfResponseContainsErrorMessage = function (response) {
        if (response.hasOwnProperty("messages")) {
            var resultMessages = response.messages;
            if (Array.isArray(resultMessages)) {
                var errorMsgs = resultMessages.filter(function (message) {
                    if (message.hasOwnProperty("level")) {
                        if (message.level === "ERROR") {
                            return true;
                        }
                    }
                    return false;
                });
                var errorMsgsStrings_1 = [];
                if (errorMsgs.length > 0) {
                    errorMsgs.forEach(function (msg) {
                        console.log(msg.message);
                        errorMsgsStrings_1.push(msg.message);
                    });
                    throw new Error(errorMsgsStrings_1.join("; "));
                }
            }
        }
    };
    ElstrIo.SERVICE_URL = "/services/";
    ElstrIo.COOKIE = "";
    return ElstrIo;
}());
exports.default = ElstrIo;
//# sourceMappingURL=ElstrIo.js.map